import Vue from "vue";
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';

export function AlertModalController () {
    this.title = '';
    this.msg = '';
    this.btnConfirm = '';
    this.btnCancel = '';
    this.tag = '',
    this.busModal = new Vue();

    this.cbConfirm = new CallbackEvent();
    this.cbCancel = new CallbackEvent();

    //#region setter
    this.setTitle = function(title) {
        this.title = title;
        return this;
    };
    this.setMsg = function(msg) {
        this.msg = msg;
        return this;
    };
    this.setBtnConfirm = function(btnConfirm) {
        this.btnConfirm = btnConfirm;
        return this;
    };
    this.setBtnCancel = function (btnCancel) {
        this.btnCancel = btnCancel;
        return this;
    };
    this.setTag = function(tag) {
        this.tag = tag;
        return this;
    };
    this.clearModal = function() {
        this.title = '';
        this.msg = '';
        this.btnConfirm = '';
        this.btnCancel = '';
        this.tag = '';
        this.cbConfirm.clearCallback();
        this.cbCancel.clearCallback();

        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            title: this.title,
            msg: this.msg,
            btnConfirm: this.btnConfirm,
            btnCancel: this.btnCancel,
            tag: this.tag,
        };
        this.busModal.$emit('show', config);
    };
    this.hide = function() {
        this.busModal.$emit('hide');
    };
    //#endregion method
}
